var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("hr", { staticClass: "before-32" }),
    _c(
      "div",
      { staticClass: "insety-16" },
      [
        _c(
          "ib-button-submit",
          {
            staticClass: "xl scanner_submit accent insetx-64",
            attrs: { disabled: _vm.disabled },
          },
          [_vm._v(_vm._s(_vm.$t("view_results")))]
        ),
        _c("input", {
          staticClass: "fg-accent reset_filter pointer",
          attrs: { type: "reset" },
          domProps: { value: _vm.$t("reset_filters") },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.resetFilter.apply(null, arguments)
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }